import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $insertNodeToNearestRoot } from "@lexical/utils";
import {
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand,
} from "lexical";
import { useEffect } from "react";

import {
  $createCallToActionNode,
  CallToActionNode,
} from "../../nodes/CallToActionNode";

export const INSERT_CALL_TO_ACTION_COMMAND: LexicalCommand<string> =
  createCommand("INSERT_CALL_TO_ACTION_COMMAND");

export type CTABorderStyle = "normal" | "rounded" | "flat";
export type CTAPosition = "end" | "start" | "center";
type Payload = {
  imgAddress: string;
  mobileImgAddress: string;
  actionLink: string;
  actionText: string;
  actionTextColor: string;
  actionTextSize: string;
  actionButtonColor: string;
  actionButtonSize: string;
  actionPosition: CTAPosition;
  borderStyle: CTABorderStyle;
  showPrice: boolean;
  priceTextColor: string;
  priceTextSize: string;
  priceHPosition: CTAPosition;
  priceVPosition: CTAPosition;
};
export type InsertCallToActionPayload = Readonly<Payload>;

export default function CallToActionPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([CallToActionNode])) {
      throw new Error(
        "CallToActionPlugin: CallToActionNode not registered on editor"
      );
    }

    return editor.registerCommand<Payload>(
      INSERT_CALL_TO_ACTION_COMMAND,
      (payload) => {
        const callToActionNode = $createCallToActionNode(payload);
        $insertNodeToNearestRoot(callToActionNode);

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
}
